export default __webpack_public_path__ + "static/media/MACHINE GUARD SIMULATOR.8dd142b8.jpg";